import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import api from "@/api";
import { useAuth } from "@/AuthContext";

export default function Welcome() {
  const { user } = useAuth();
  const navigate = useNavigate();
  const hour = new Date().getHours();
  const greeting = hour < 12 ? "Good Morning" : hour < 17 ? "Good Afternoon" : "Good Evening";
  const home = user.role === "team_leader" ? "/app" : user.role === "super_admin" && !user.active_tenant_id ? "/choose-workspace" : "/admin";

  useEffect(() => {
    if (!user || user.role === "super_admin" || user.is_workspace_owner) return;
    api.get("/attendance/status").then(({ data }) => {
      if (data?.requires_checkin && data?.blocking) {
        navigate("/check-in", { replace: true });
      }
    }).catch(() => {});
  }, [user, navigate]);

  const handleContinue = () => {
    if (!user || user.role === "super_admin" || user.is_workspace_owner) {
      navigate(home, { replace: true });
      return;
    }
    api.get("/attendance/status").then(({ data }) => {
      if (data?.requires_checkin && data?.blocking) {
        navigate("/check-in", { replace: true });
        return;
      }
      navigate(home, { replace: true });
    }).catch(() => {
      navigate(home, { replace: true });
    });
  };

  return (
    <main className="min-h-screen grid place-items-center bg-background px-5" data-testid="attendance-greeting-screen">
      <section className="w-full max-w-xl border-l-4 border-primary py-3 pl-6">
        <p className="text-xs font-semibold uppercase tracking-widest text-muted-foreground">{new Date().toLocaleDateString([], { weekday: "long", day: "numeric", month: "long" })}</p>
        <h1 className="mt-3 font-heading text-4xl font-bold">{greeting}, {user.name?.split(" ")[0]}</h1>
        <button type="button" onClick={handleContinue} className="mt-8 inline-flex h-11 items-center gap-2 rounded-md bg-primary px-5 font-semibold text-primary-foreground hover:bg-primary/90">
          Continue <ArrowRight size={16} />
        </button>
      </section>
    </main>
  );
}
